export const  getTradeCount = (arr:any)=>{
    let returnReferenceObj: any = {
        'IOI': 'options',
        'SOI': 'options',
        'ESM': 'equity',
        'EBM': 'equityN50BANK',
        'AIOBANDDI': 'lft',
        'AIONIFDDI': 'lft',
        'IFI': 'futures',
        'SFI': 'futures',
        'CFI': 'futures'
    }
    let tradeObj = {   
                    futures: 0,
                    options:0,
                    lft: 0,
                    equity: 0,
                    equityN50BANK: 0,
                    equityN50plus:0,
                    optLong: 0
                }
        
    arr?.map((item:any)=>{
        
        let title_name:any = (item !== 'AIOBANDDI' && item !== 'AIONIFDDI' && item !='AIONIFKKI') ? item.slice(0, 3)==='EBM'?'equityN50BANK':returnReferenceObj[item.slice(1, 3) + (item.split('-')[0]).slice(-1)] : item =='AIONIFKKI'? 'optLong':'lft'
        if (title_name!==undefined )
        {
        if (title_name === 'equity') {tradeObj.equity +=1}
        else if (title_name === 'futures') {tradeObj.futures +=1}
        else if (title_name === 'options') {tradeObj.options +=1}
        else if (title_name === 'lft') {tradeObj.lft +=1}
        else if (title_name === 'optLong') {tradeObj.optLong +=1}
        else if (title_name === 'equityN50plus') {tradeObj.equityN50plus +=1}
        else if (title_name === 'equityN50BANK') {tradeObj.equityN50BANK +=1}
        }  
})

return tradeObj
}